import axios from 'axios';

import { BasicUserInfo } from '../interfaces/BasicUserInfo';
import { PagingResult } from '../interfaces/pagination';

export interface SpecCommentStatusType {
  id: number
  specId: string
  authorId: string
  author?: BasicUserInfo
  specName: string
  content: string
  total: number
  unseenTotal: number
  createdAt: string
}

class SpecCommentStatus implements SpecCommentStatusType {
  id: number
  specId: string
  authorId: string
  author?: BasicUserInfo
  specName: string
  content: string
  total: number
  unseenTotal: number
  createdAt: string

  constructor(status: SpecCommentStatusType) {
    this.id = status.id;
    this.specId = status.specId;
    this.authorId = status.authorId;
    this.author = status.author;
    this.specName = status.specName;
    this.content = status.content;
    this.total = status.total;
    this.unseenTotal = status.unseenTotal;
    this.createdAt = status.createdAt;
  }

  // returns spec comment list
  static async find(query?: { specId?: string, [key: string]: any }): Promise<PagingResult<SpecCommentStatus>> {
    const { data } = await axios.get<PagingResult<SpecCommentStatusType>>('/spec/comment-status/list', {
      params: query
    });
    return { ...data, items: data.items.map(s => new SpecCommentStatus(s)) };
  }
}

export default SpecCommentStatus;
